import {
    SignInContent,
    SignInRouteConfig,
    SignInSocialLink,
    SignInValidationMessages,
} from "./SignInTypes";

export const signInRoutes: SignInRouteConfig = {
    home: "/HomePage",
    signUp: "/SignUp",
    forgotPassword: "/ForgotPassword",
};

export const signInContent: SignInContent = {
    title: "Welcome Back to Salar!",
    subtitle: "Sign in to continue to your Salar account.",
    customerIdPlaceholder: "Enter Customer ID, Email or Mobile No",
    passwordPlaceholder: "Enter Password",
    signInLabel: "Sign in",
    signingInLabel: "Signing in...",
    signUpPrompt: "Don't have an account?",
    signUpLabel: "Sign up",
    forgotPasswordLabel: "Forgot Password",
    socialTitle: "Follow Salar social media official accounts",
    brandAlt: "Salar",
    heroAlt: "Salar shopping experience",
};

export const signInValidationMessages: SignInValidationMessages = {
    customerIdRequired: "Customer ID, Email or Mobile is required",
    passwordRequired: "Password is required",
};

export const signInSocialLinks: SignInSocialLink[] = [
    {
        id: "instagram",
        label: "Instagram",
        href: "https://www.instagram.com",
        iconClass: "bi bi-instagram",
    },
    {
        id: "facebook",
        label: "Facebook",
        href: "https://www.facebook.com",
        iconClass: "bi bi-facebook",
    },
    {
        id: "whatsapp",
        label: "WhatsApp",
        href: "https://www.whatsapp.com",
        iconClass: "bi bi-whatsapp",
    },
    {
        id: "x",
        label: "X",
        href: "https://x.com",
        iconClass: "bi bi-twitter-x",
    },
    {
        id: "youtube",
        label: "YouTube",
        href: "https://www.youtube.com",
        iconClass: "bi bi-youtube",
    },
];
